import { CreateGygActivityDto } from '@routellers/types/dist/gyg-activity/create-gyg-activity.dto';
import { GygActivityStatusEnum } from '@routellers/types/dist/gyg-activity/enum/gyg-activity-status.enum';
import {
    GygActivityRO,
    GygTourSearchHitRO,
} from '@routellers/types/dist/gyg-activity/gyg-activity.ro';
import { UpdateGygActivityDto } from '@routellers/types/dist/gyg-activity/update-gyg-activity.dto';

import { ApiMethodDeclaration } from '..';

const config: ApiMethodDeclaration<void, { configured: boolean; partnerId: string | null }> = () => ({
    url: '/admin/gyg-activities/config',
    method: 'GET',
});

const search: ApiMethodDeclaration<
    {
        cityId: number;
        q?: string;
        limit?: number;
        language?: string;
        currency?: string;
    },
    GygTourSearchHitRO[]
> = (params) => ({
    url: '/admin/gyg-activities/search',
    method: 'GET',
    params,
});

const list: ApiMethodDeclaration<
    { cityId?: number; status?: GygActivityStatusEnum } | void,
    GygActivityRO[]
> = (params) => ({
    url: '/admin/gyg-activities',
    method: 'GET',
    params: params || undefined,
});

const getOne: ApiMethodDeclaration<number, GygActivityRO> = (id) => ({
    url: `/admin/gyg-activities/${id}`,
    method: 'GET',
});

const create: ApiMethodDeclaration<{ data: CreateGygActivityDto }, GygActivityRO> = ({ data }) => ({
    url: '/admin/gyg-activities',
    method: 'POST',
    data,
});

const update: ApiMethodDeclaration<
    { id: number; data: UpdateGygActivityDto },
    GygActivityRO
> = ({ id, data }) => ({
    url: `/admin/gyg-activities/${id}`,
    method: 'PATCH',
    data,
});

const sync: ApiMethodDeclaration<number, GygActivityRO> = (id) => ({
    url: `/admin/gyg-activities/${id}/sync`,
    method: 'POST',
});

const remove: ApiMethodDeclaration<number, { ok: true }> = (id) => ({
    url: `/admin/gyg-activities/${id}`,
    method: 'DELETE',
});

export const gygActivitiesApiDeclaration = {
    config,
    search,
    list,
    getOne,
    create,
    update,
    sync,
    remove,
};
